<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.refund.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="layout-bonus">
          <label>{{ $t('modals.refund.refundAmountLabel') }}</label>
          <div class="amount">
            {{ refundAmount | decimalFormat }}
            {{ $t('modals.transfer.bahtTxt') }}
          </div>

          <button class="button small is-success" @click="addRefundToWallet">
            {{ $t('modals.refund.receiveBtn') }}
          </button>
        </div>
        <div class="my-code">
          <div v-html="refundInfo"></div>
          <br />
          <div class="detail">
            <div v-if="hasRefund === true">
              <button
                type="button"
                class="button small is-primary"
                @click="receiveRefund"
                :disabled="hasBonus"
              >
                {{ $t('modals.refund.receiveRefundBtn') }}
              </button>
              <div v-if="hasBonus" class="has-text-danger">
                {{ $t('modals.refund.refundCon1Txt') }}<br />{{
                  $t('modals.refund.refundCon2Txt')
                }}
              </div>
            </div>
            <div v-else class="has-text-danger">
              {{ $t('modals.refund.refundNotFondTxt') }}
            </div>
          </div>
          <br />
        </div>
        <b-table
          class="m-t-20"
          :data="refundLog"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page="current"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :range-before="3"
          :range-after="1"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column label="จำนวนเงิน (บาท)" numeric>
              {{ props.row.refundAmount }}
            </b-table-column>
            <b-table-column label="วันที่ได้รับ" centered>
              {{ props.row.createdAt | datetimeFormat }}
            </b-table-column>
          </template>
        </b-table>
      </section>
    </div>
  </div>
</template>

<script>
import apiRefund from '@/api/refund'
import i18n from '@/language'
export default {
  name: 'ModalRefund',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object
    }
  },
  data() {
    return {
      refundLog: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      current: 1,
      perPage: 10,
      hasRefund: false,
      hasBonus: false,
      refundInfo: '',
      refundAmount: 0,
      refundSuccess: 0,
      refundFail: 0
    }
  },
  mounted() {
    this.checkRefund()
    this.getRefund()
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', null)
    },
    async checkRefund() {
      const data = await apiRefund.checkRefundBonus()
      this.hasRefund = data.result
      this.hasBonus = data.bonus
      this.refundInfo = data.info
      this.refundAmount = data.refundAmount
      this.refundSuccess = data.refundSuccess
      this.refundFail = data.refundFail
    },
    async getRefund() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiRefund.getRefund(this.current, this.perPage)
          this.refundLog = data.refunds

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    async receiveRefund() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiRefund.receviedRefundBonus()
          if (data) {
            this.$buefy.toast.open({
              message: data.message,
              type: 'is-success'
            })
          }
        } catch (error) {
          this.$buefy.toast.open({
            message: error.message ? error.message : error,
            type: 'is-danger'
          })
        } finally {
          this.checkRefund()
          loading.hide()
        }
      }, 200)
    },
    async addRefundToWallet() {
      this.$buefy.dialog.confirm({
        title: i18n.t('modals.refund.refundToWallet1Msg'),
        message: `*** ${i18n.t('modals.refund.refundToWallet2Msg')} ***${
          this.refundSuccess > 0
            ? `<br><br>${i18n.t('modals.refund.refundToWallet3Msg')} <b>${
                this.refundSuccess
              }%</b> ${i18n.t('modals.refund.refundToWallet4Msg')}<br><br>` +
              `*** ${i18n.t('modals.refund.refundToWallet5Msg')} <b>${
                this.refundFail
              }%</b>
            ${i18n.t('modals.refund.refundToWallet6Msg')}
            <span class="has-text-danger"><b>${i18n.t(
              'modals.refund.refundToWallet7Msg'
            )}</b></span> ***</div><br>`
            : ''
        }`,
        confirmText: i18n.t('bonus.confirmMsg'),
        cancelText: i18n.t('bonus.cancelMsg'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            await apiRefund.addRefundToWallet()
            this.$buefy.toast.open({
              message: i18n.t('modals.successMsg'),
              type: 'is-success'
            })

            this.$emit('closeModal', true)
          } catch (error) {
            this.$buefy.toast.open({
              message: error,
              type: 'is-danger'
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.my-code {
  width: 100%;
  text-align: center;
}

.button {
  margin-left: 10px;
  &.small {
    padding: 5px 10px !important;
    border-radius: 10px;
    height: fit-content;
  }
}

.layout-bonus {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 30px 0;

  label {
    font-size: 1.1em;
    font-weight: bold;
  }

  .amount {
    width: 120px;
    background: white;
    border-radius: 20px;
    padding: 0 10px;
    color: black;
    text-shadow: none;
    text-align: right;
  }
}
</style>
